import { useState } from "react";
import { useAppState } from "./Context";
import { getTitle } from "../helper/main";

const SearchBarComponent = ({ query, setQuery }) => {
    const [focused, setFocused] = useState(false);
    const { state } = useAppState();
    const isActive = focused || query.length > 0;

    const handleChange = (e) => {
        setQuery(e.target.value);
    };

    return (
        <div className={`search-bar-container collectdiv-outline ${isActive ? "active" : ""}`}>
            
            {!focused && !query && (
                <svg className="search-icon" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="7" stroke="white" strokeWidth="2" fill="none"/>
                    <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="white" strokeWidth="2"/>
                </svg>
            )}

            <input
                className="search-bar"
                type="text"
                placeholder={focused ? `Search ${getTitle(state)}` : ""}
                value={query}
                onChange={handleChange}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
            />
        </div>
    );
};

export default SearchBarComponent;